// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#bf2235","secondaryColor":"#3a281b"};